/**
 * Modular PDP — COA lightbox.
 * Init via [data-modular-pdp-coa]. No optional chaining.
 */
(function (doc, win) {
  'use strict';

  var scrollY = 0;
  var lastFocus = null;
  var activeLightbox = null;

  function lockScroll() {
    scrollY = win.pageYOffset || doc.documentElement.scrollTop || 0;
    doc.body.style.position = 'fixed';
    doc.body.style.top = '-' + scrollY + 'px';
    doc.body.style.left = '0';
    doc.body.style.right = '0';
    doc.body.style.width = '100%';
  }

  function unlockScroll() {
    var html = doc.documentElement;
    var prevBehavior = html.style.scrollBehavior;
    // Pages with html { scroll-behavior: smooth } would animate top → scrollY on restore.
    html.style.scrollBehavior = 'auto';
    doc.body.style.position = '';
    doc.body.style.top = '';
    doc.body.style.left = '';
    doc.body.style.right = '';
    doc.body.style.width = '';
    win.scrollTo(0, scrollY);
    html.style.scrollBehavior = prevBehavior;
  }

  function activateTab(root, index) {
    if (!root) return;
    var tabs = root.querySelectorAll('[data-coa-tab]');
    var panels = root.querySelectorAll('[data-coa-panel]');
    var i;
    var key = String(index);

    for (i = 0; i < tabs.length; i++) {
      var isActive = tabs[i].getAttribute('data-coa-tab') === key;
      tabs[i].classList.toggle('is-active', isActive);
      tabs[i].setAttribute('aria-selected', isActive ? 'true' : 'false');
    }

    for (i = 0; i < panels.length; i++) {
      var show = panels[i].getAttribute('data-coa-panel') === key;
      panels[i].classList.toggle('is-active', show);
      if (show) {
        panels[i].removeAttribute('hidden');
      } else {
        panels[i].setAttribute('hidden', '');
      }
    }

    var dialog = root.querySelector('.modular-pdp-coa__dialog');
    if (dialog) dialog.scrollTop = 0;
  }

  function defaultIndex(root) {
    var raw = root.getAttribute('data-coa-default');
    var parsed = parseInt(raw, 10);
    if (isNaN(parsed) || parsed < 0) return 0;
    return parsed;
  }

  function openLightbox(root, indexAttr) {
    if (!root) return;

    var index = defaultIndex(root);
    if (indexAttr !== undefined && indexAttr !== null && String(indexAttr) !== '') {
      var parsed = parseInt(indexAttr, 10);
      if (!isNaN(parsed) && parsed >= 0) index = parsed;
    }

    if (activeLightbox === root) {
      activateTab(root, index);
      return;
    }

    lastFocus = doc.activeElement;
    activeLightbox = root;
    activateTab(root, index);
    root.hidden = false;
    root.classList.add('is-open');
    lockScroll();
    doc.addEventListener('keydown', onKeydown);

    var closeBtn = root.querySelector('[data-coa-close]');
    if (closeBtn && typeof closeBtn.focus === 'function') {
      closeBtn.focus();
    }
  }

  function closeLightbox() {
    if (!activeLightbox) return;
    activeLightbox.classList.remove('is-open');
    activeLightbox.hidden = true;
    activeLightbox = null;
    doc.removeEventListener('keydown', onKeydown);
    unlockScroll();
    if (lastFocus && typeof lastFocus.focus === 'function') {
      lastFocus.focus();
    }
    lastFocus = null;
  }

  function onKeydown(e) {
    if (e.key === 'Escape' || e.keyCode === 27) {
      closeLightbox();
    }
  }

  function bind(root) {
    if (!root || root.getAttribute('data-coa-bound') === 'true') return;
    root.setAttribute('data-coa-bound', 'true');

    root.addEventListener('click', function (e) {
      var t = e.target;
      if (!t) return;
      var closeHit = typeof t.closest === 'function' ? t.closest('[data-coa-close]') : null;
      if (closeHit) {
        e.preventDefault();
        closeLightbox();
        return;
      }
      var tabHit = typeof t.closest === 'function' ? t.closest('[data-coa-tab]') : null;
      if (tabHit) {
        activateTab(root, tabHit.getAttribute('data-coa-tab'));
      }
    });
  }

  function bindOpeners() {
    if (doc.documentElement.getAttribute('data-coa-openers') === 'true') return;
    doc.documentElement.setAttribute('data-coa-openers', 'true');

    doc.addEventListener('click', function (e) {
      var t = e.target;
      if (!t) return;
      var opener = typeof t.closest === 'function' ? t.closest('[data-coa-open]') : null;
      if (!opener) return;
      var root = doc.querySelector('[data-modular-pdp-coa]');
      if (!root) return;
      e.preventDefault();
      openLightbox(root, opener.getAttribute('data-coa-index'));
    });
  }

  function init() {
    var nodes = doc.querySelectorAll('[data-modular-pdp-coa]');
    var i;
    for (i = 0; i < nodes.length; i++) {
      bind(nodes[i]);
    }
    if (nodes.length) bindOpeners();
  }

  if (doc.readyState === 'loading') {
    doc.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})(document, window);
